import React, { ReactNode } from 'react';
import styles from './FloFilterGroup.module.css';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FloComponentProps } from 'components';
import { Row, Col } from 'react-bootstrap';


interface FloFilterGroupProps extends FloComponentProps {
  children:   ReactNode;
  label:      string;
  onClear?:   () => void;
}

export const FloFilterGroup: React.FC<FloFilterGroupProps> = React.memo(({
  className,
  children,
  label,
  onClear,
}) => {
  const { t } = useTranslation();

  return (
    <Row className={classnames(className, styles.root)}>
      <Col xs="12">
        <Row className={styles.header}>
          <Col xs={onClear ? '7' : '12'}><span className={styles.label}>{label}</span></Col>
          { onClear ?
            <Col xs="5" className={styles.clearWrapper}><span className={styles.clear} onClick={onClear}>{t('Clear')}</span></Col>
            : null
          }
        </Row>
        <Row>
          <Col xs="12">{children}</Col>
        </Row>
      </Col>
    </Row>
  )
})